
  export default {
    name: 'HappyKidsTutorialBlogCardMobile',
    props: {
      data: {
        type: Object,
        default: () => ({
          title: '因新型肺炎而取消行程，旅遊保險有無得保？',
          tags: ['旅遊保險'],
          date: '2021年07月19日',
          readtime: '3分鐘閱讀',
          author: '10Life 編輯團隊'
        }),
      },
    },
    data() {
      return {
        activeItem: "lifestageoffering-1",
        strapiData: []
      }
    },
    computed: {
    },
    methods: {
    },
  }
  